import { LeaderboardActions } from '@/types/leaderboard.types';

interface ILeaderboardCss {
  custom_css?: string;
  compiled_css?: string;
  custom_css_compiled?: string | null;
  use_safe_css?: boolean;
}

export type LeaderboardSettings = {
  enabled?: boolean;
  upload_url?: string; // removed from eventBundle
  upload_filename?: string; // removed from eventBundle
  styles?: ILeaderboardCss;
  filter_question?: number | null;
  byline_question?: number | null;
};

// const dictionary for leaderboard action card labels
export const actionLabelMap: Record<number, string> = {
  [LeaderboardActions.registered]: 'Award points for successful registration',
  [LeaderboardActions.watched_minute]: 'Award points for each minute of video watched',
  [LeaderboardActions.quiz_answer_correct]: 'Award points for correctly answered quiz questions',
};
